module.exports = __webpack_public_path__ + "static/media/annual-physical.aef23a60.jpg";